module.exports = __WEBPACK_EXTERNAL_MODULE__76878__;